import React from "react";
import Button from "../button/Button";
import "./modal.css"

const Modal = (
    { 
        title="", 
        onCancel, 
        onConfirm, 
        loading=false, 
        confirmDisabled=false, 
        cancelText="Cancel", 
        submitText="Submit",
        children
    }
) => {

    // check if the click was targeting the background (outside the modal)
    // if so, close the modal
    const checkOutsideClick = e => {
        if (e.target.className === "modal-outer" || e.target.className === "modal-inner") {
            onCancel()
        }
    }

    return (
        <div className="modal-outer" onClick={e => checkOutsideClick(e)}>
            <div className="modal-inner">
                <div className="modal-box">
                    <div className="modal-header">
                        <h2>{title}</h2>
                        <Button 
                            onClick={() => onCancel()}
                            text={<i className="fas fa-times" />}
                        />
                    </div>
                    {children}
                    <div className="modal-actions">
                        <Button 
                            onClick={() => onCancel()} 
                            style={{ marginRight: "15px" }}
                            text={cancelText}
                        />
                        <Button 
                            type="primary" 
                            onClick={() => onConfirm()}
                            loading={loading}
                            disabled={confirmDisabled}
                            text={submitText}
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Modal;